/**
 * Designed  & Developed by Faisal Nadaf
 * Contact: faisalfnadaf@gmail.com
 *
 * @format
 */

import { Navigation } from "@/components/customCopmonent/landingSection/navigation";
import { FooterSection } from "@/components/customCopmonent/landingSection/footer-section";
import CircularGallery from "@/components/customCopmonent/CircularGallery";
import DotGrid from "@/components/customCopmonent/DotGrid";
import { PageHeaderHero, PAGE_HERO_CLASS } from "@/components/customCopmonent/Text/PageHeaderHero";
import { SectionWrapper } from "../Clientele.page-primitives";
import { PageHeader } from "@/components/customCopmonent/Text/PageHeader";
import { RevealOnScroll } from "@/components/SpecialProjectsPage.primitives";

import React, { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import { useTranslation } from "react-i18next";
import Seo from "@/components/Seo";
import { useIsMobile } from "@/hooks/hooks/use-mobile";
import {
	IndustrySectionProduct,
	IndustrySectionApplication,
} from "@/components/customCopmonent/IndustryCardsAP";

// Register ScrollTrigger
if (typeof window !== "undefined") {
	gsap.registerPlugin(ScrollTrigger);
}

const SteelMetallurgy = () => {
	const { t } = useTranslation();

	const subIndustryImages = [
		"/images/industriesPhotos/Steel&Metallurgy/SubIndustries/Integrated Steel Plants.webp",
		"/images/industriesPhotos/Steel&Metallurgy/SubIndustries/Rolling Mills.webp",
		"/images/industriesPhotos/Steel&Metallurgy/SubIndustries/Foundries.webp",
		"/images/industriesPhotos/Steel&Metallurgy/SubIndustries/Smelters.webp",
		"/images/industriesPhotos/Steel&Metallurgy/SubIndustries/Metal Processing Units.webp",
		"/images/industriesPhotos/Steel&Metallurgy/SubIndustries/Aluminum & Non-Ferrous.webp",
	];

	const applicationImages = [
		"/images/industriesPhotos/Steel&Metallurgy/Application/Furnace Cooling.webp",
		"/images/industriesPhotos/Steel&Metallurgy/Application/Continuous Casting Cooling.webp",
		"/images/industriesPhotos/Steel&Metallurgy/Application/Rolling Mill Oil Cooling.webp",
		"/images/industriesPhotos/Steel&Metallurgy/Application/Blast Furnace Gas Cooling.webp",
		"/images/industriesPhotos/Steel&Metallurgy/Application/Steam Condensation.webp",
		"/images/industriesPhotos/Steel&Metallurgy/Application/Waste Heat Recovery Systems.webp",
		"/images/industriesPhotos/Steel&Metallurgy/Application/Air Preheating.webp",
	];

	const subIndustryTexts = t(
		"industryPages.steelMetallurgy.subIndustries.items",
		{ returnObjects: true },
	) as string[];
	const applicationItems = t(
		"industryPages.steelMetallurgy.applications.items",
		{ returnObjects: true },
	) as { title: string; description: string }[];

	const pageData = {
		title: t("industryPages.steelMetallurgy.title"),
		bgimage: "/images/header/steel.webp",

		description: t("industryPages.steelMetallurgy.tagline"),

		meta: t("industryPages.steelMetallurgy.meta", {
			returnObjects: true,
		}) as string[],

		subIndustries: {
			title: t("industryPages.steelMetallurgy.subIndustries.title"),

			industries: subIndustryImages.map((image, i) => ({
				image,
				text: subIndustryTexts[i],
			})),
		},

		applications: {
			title: t("industryPages.steelMetallurgy.applications.title"),

			applications: applicationImages.map((image, i) => ({
				image,
				title: applicationItems[i].title,
				description: applicationItems[i].description,
			})),
		},
	};
	const isMobile = useIsMobile();

	return (
		<>
			<Seo
				titleKey="industryPages.steelMetallurgy.seo.title"
				descriptionKey="industryPages.steelMetallurgy.seo.description"
				path="/industries/steel-metallurgy"
			/>
			<Navigation />
			<SectionWrapper className={PAGE_HERO_CLASS}>
				<div className="absolute inset-0 ">
					{" "}
					<div
						className="absolute bottom-3 inset-0 opacity-35 scale-105"
						style={{
							backgroundImage: `url(${pageData.bgimage})`,
							backgroundSize: "cover",
							backgroundPosition: "center",
						}}
					/>
					<DotGrid
						dotSize={4}
						gap={15}
						baseColor="#3b0092"
						activeColor="#f09a38"
						proximity={100}
						shockRadius={200}
						shockStrength={3}
						resistance={750}
						returnDuration={1.5}
					/>
				</div>
				<PageHeaderHero
					// align="center"
					title={pageData.title}
					description={pageData.description}
					meta={pageData.meta}
				/>
			</SectionWrapper>
			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				{" "}
				<div className="relative flex flex-col items-center justify-center ">
					{/* ===== HEADER ===== */}
					<RevealOnScroll>
						<PageHeader
							title={pageData.subIndustries.title}
							align="center"
							className="py-6 text-center items-center "
						/>
					</RevealOnScroll>
				</div>
				<div className="relative h-[360px] sm:h-[460px] lg:h-[600px]">
					<CircularGallery
						items={pageData.subIndustries.industries}
						textColor="#000"
						borderRadius={0.05}
						bend={isMobile ? 0 : -3}
						scrollSpeed={1.5}
						scrollEase={0.05}
					/>
				</div>
			</SectionWrapper>
			<SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<IndustrySectionApplication
					applications={pageData.applications.applications}
					title={pageData.applications.title}
				/>{" "}
			</SectionWrapper>
			{/* <SectionWrapper
				className="pt-0  !px-0 !max-w-none"
				contentClassName="!max-w-none !px-0">
				<IndustrySectionProduct
					applications={pageData.products.products}
					title={pageData.products.title}
					description={pageData.products.description}
				/>{" "}
			</SectionWrapper> */}
			<FooterSection />
		</>
	);
};

export default SteelMetallurgy;
